import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header Simple */}
      <header className="bg-white shadow-sm border-b border-gray-100">
        <div className="container-max">
          <div className="flex justify-between items-center py-4 px-4 sm:px-6 lg:px-8">
            <div 
              className="flex items-center cursor-pointer" 
              onClick={() => navigate('/')}
            >
              <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center mr-3 shadow-lg">
                <span className="text-white font-bold text-lg">T</span>
              </div>
              <span className="text-2xl font-bold text-gray-900">Tareia</span>
            </div>
            
            <button 
              onClick={() => navigate('/')}
              className="text-gray-600 hover:text-primary-600 transition-colors font-medium"
            >
              ← Volver
            </button>
          </div>
        </div>
      </header>

      {/* Contenido */}
      <main className="py-16">
        <div className="container-max">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center">
              Términos y Condiciones
            </h1>
            
            <div className="prose prose-lg max-w-none">
              <div className="space-y-8 text-gray-700 leading-relaxed">
                <p className="text-xl">
                  Tareia es un producto en fase de validación y acceso anticipado.
                </p>
                
                <p>
                  Al registrarte, aceptas recibir información relacionada con el desarrollo y lanzamiento del producto.
                </p>
                
                <p>
                  <strong>El acceso anticipado no garantiza disponibilidad inmediata ni funcionalidades específicas</strong>, ya que el producto puede cambiar durante su desarrollo.
                </p>
                
                <p>
                  Tareia no se hace responsable por el uso que se le dé a la información generada durante esta fase.
                </p>
                
                <p>
                  Nos reservamos el derecho de actualizar estos términos en cualquier momento.
                </p>
                
                <p>
                  Para cualquier duda, puedes contactarnos en: <a href="mailto:contacto@tareia.com" className="text-primary-600 hover:text-primary-700">contacto@tareia.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer Simple */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container-max">
          <div className="text-center">
            <div className="flex justify-center space-x-6 mb-4">
              <button 
                onClick={() => navigate('/privacidad')}
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Privacidad
              </button>
              <span className="text-gray-600">|</span>
              <button 
                onClick={() => navigate('/terminos')}
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Términos
              </button>
            </div>
            <div className="text-gray-500 text-sm">
              © 2026 Tareia
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;